var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.795,
    height: 129.795,
    viewBox: "0 0 129.795 129.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e2e2e2;stroke:#e2e2e2;stroke-width:1.5px;}.b{fill:#f37d27;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.507,18.788a64.148,64.148,0,0,0-90.718,90.719,64.148,64.148,0,0,0,90.718-90.719Zm-5.315,85.4A56.63,56.63,0,0,1,24.1,24.1a56.63,56.63,0,1,1,80.087,80.087Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.76 45.76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -11.433)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M195.87,190.6l-22.748-22.748L195.87,145.11a3.723,3.723,0,0,0-5.266-5.265l-22.747,22.747-22.748-22.748a3.723,3.723,0,0,0-5.266,5.266l22.748,22.748L139.843,190.6a3.723,3.723,0,0,0,5.266,5.266l22.748-22.748L190.6,195.871a3.723,3.723,0,0,0,5.266-5.266Z",
    transform: "translate(-138.753 -138.753)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.024ee34f8843a49e7f78f4442d9bd640.svg";
export { ForwardRef as ReactComponent };